<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ !isUpdate ? $t('adicionar-tipopedido') : $t('tipopedido') }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        $route.query.contexto == 'ven' ? $t('vendas') : $t('agro')
                                    }}</a>
                                </li>
                                <li>
                                    <a @click="$router.push({ name: 'ven-tipopedido' })">{{
                                        $t('tipopedido')
                                    }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $route.params.id ? $route.params.id : $t('novo')
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button class="delete-btn" type="button" tag="button" @click="fecharModal">
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-if="
                                (!integracao && !isUpdate && permissao.create) ||
                                (!integracao && isUpdate && permissao.update)
                            "
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-2">
                            <v-input
                                :id="generateId(89)"
                                ref="idErpInput"
                                v-model="tipopedido.idtipopedidoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                :invalid="!tipopedido.idtipopedidoerp"
                                tooltipLabel="cod-ref"
                            />
                        </div>
                        <div class="column is-5">
                            <v-input
                                :id="generateId(1)"
                                ref="descricaoInput"
                                v-model="tipopedido.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="descricao"
                                msg="msg-campo-obrigatorio"
                                :required="true"
                                :invalid="isNull(tipopedido.descricao)"
                                :disabled="cantEdit"
                                tooltipLabel="informacao-tipopedido-descricao"
                                tooltipPosition="is-right"
                                tooltipSize="is-small"
                            />
                        </div>
                        <div class="column is-5">
                            <vss-select
                                :id="generateId(21)"
                                ref="empresaInput"
                                title="empresa"
                                :searchable="false"
                                :options="empresaSelect"
                                v-model="empresaSelected"
                                class="no-clear"
                                :required="true"
                                tooltipLabel="informacao-tipopedido-empresa"
                                tooltipPosition="is-top"
                                @onBlurFunction="sendIsChanged()"
                                :loading="empresasLoading"
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                :id="generateId(15)"
                                ref="tipoInput"
                                title="tipo"
                                :searchable="false"
                                :options="tipoSelect"
                                v-model="tipoSelected"
                                class="no-clear"
                                tooltipLabel="informacao-tipopedido-tipo"
                                tooltipPosition="is-right"
                                :required="true"
                                :mlLabels="true"
                                :disabled="cantEdit"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                :id="generateId(2)"
                                ref="geraimpostoInput"
                                title="geraimposto"
                                :searchable="false"
                                :options="simNao"
                                v-model="geraimpostoSelected"
                                class="no-clear"
                                tooltipLabel="informacao-tipopedido-geraimposto"
                                tooltipPosition="is-top"
                                :required="true"
                                :mlLabels="true"
                                :disabled="cantEdit"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                :id="generateId(3)"
                                ref="faturaInput"
                                title="fatura"
                                :searchable="false"
                                :options="simNao"
                                v-model="faturaSelected"
                                class="no-clear"
                                tooltipLabel="informacao-tipopedido-fatura"
                                tooltipPosition="is-top"
                                :required="true"
                                :mlLabels="true"
                                :disabled="cantEdit"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                :id="generateId(4)"
                                ref="imprimeInput"
                                title="imprime"
                                :searchable="false"
                                :options="simNao"
                                v-model="imprimeSelected"
                                class="no-clear"
                                tooltipLabel="informacao-tipopedido-imprime"
                                tooltipPosition="is-left"
                                :required="true"
                                :mlLabels="true"
                                :disabled="cantEdit"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                :id="generateId(5)"
                                ref="negativaestoquelocalInput"
                                title="negativaestoquelocal"
                                :searchable="false"
                                :options="simNao"
                                v-model="negativaestoquelocalSelected"
                                class="no-clear"
                                tooltipLabel="informacao-tipopedido-negativaestoquelocal"
                                tooltipPosition="is-right"
                                :required="true"
                                :mlLabels="true"
                                :disabled="cantEdit"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                :id="generateId(6)"
                                ref="habilitaordemcompraInput"
                                title="habilitaordemcompra"
                                :searchable="false"
                                :options="simNao"
                                v-model="habilitaordemcompraSelected"
                                class="no-clear"
                                tooltipLabel="informacao-tipopedido-habilitaordemcompra"
                                tooltipPosition="is-top"
                                :required="true"
                                :mlLabels="true"
                                :disabled="cantEdit"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                :id="generateId(7)"
                                ref="solicitacontrasenhaInput"
                                title="solicitacontrasenha"
                                :searchable="false"
                                :options="simNao"
                                v-model="solicitacontrasenhaSelected"
                                class="no-clear"
                                tooltipLabel="informacao-tipopedido-solicitacontrasenha"
                                tooltipPosition="is-top"
                                :required="true"
                                :mlLabels="true"
                                :disabled="cantEdit"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                :id="generateId(8)"
                                ref="solicitamotivotipopedidoInput"
                                title="solicitamotivotipopedido"
                                :searchable="false"
                                :options="simNao"
                                v-model="solicitamotivotipopedidoSelected"
                                class="no-clear"
                                tooltipLabel="informacao-tipopedido-solicitamotivotipopedido"
                                tooltipPosition="is-left"
                                :required="true"
                                :mlLabels="true"
                                :disabled="cantEdit"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                :id="generateId(9)"
                                ref="alertasaldominimoInput"
                                title="alertasaldominimo"
                                :searchable="false"
                                :options="simNao"
                                v-model="alertasaldominimoSelected"
                                class="no-clear"
                                tooltipLabel="informacao-tipopedido-alertasaldominimo"
                                tooltipPosition="is-right"
                                :required="true"
                                :mlLabels="true"
                                :disabled="cantEdit"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                :id="generateId(21)"
                                ref="consomeFlexPedVinculadoInput"
                                title="permite-pedidos-consumir-saldo-flex"
                                :searchable="false"
                                :options="simNao"
                                v-model="consomeFlexPedVinculadoSelected"
                                class="no-clear"
                                tooltipLabel="tooltip-consome-flex-pedido-vinculado"
                                tooltipPosition="is-top"
                                :required="true"
                                :mlLabels="true"
                                :disabled="cantEdit"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                :id="generateId(9)"
                                ref="descflexvlrmenorInput"
                                title="descflexvlrmenor"
                                :searchable="false"
                                :options="simNao"
                                v-model="descflexvlrmenorSelected"
                                class="no-clear"
                                tooltipLabel="informacao-tipopedido-descflexvlrmenor"
                                tooltipPosition="is-top"
                                :required="true"
                                :mlLabels="true"
                                :disabled="cantEdit"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                :id="generateId(10)"
                                ref="acresflexvlrmaiorInput"
                                title="acresflexvlrmaior"
                                :searchable="false"
                                :options="simNao"
                                v-model="acresflexvlrmaiorSelected"
                                class="no-clear"
                                tooltipLabel="informacao-tipopedido-acresflexvlrmaior"
                                tooltipPosition="is-top"
                                :required="true"
                                :mlLabels="true"
                                :disabled="cantEdit"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                :id="generateId(15)"
                                ref="descvalortotalitemflexInput"
                                title="descvalortotalitemflex"
                                :options="simNao"
                                v-model="descvalortotalitemflexSelected"
                                class="no-clear"
                                tooltipLabel="informacao-tipopedido-descvalortotalitemflex"
                                tooltipPosition="is-top"
                                :required="true"
                                :mlLabels="true"
                                :disabled="cantEdit"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                :id="generateId(11)"
                                ref="subtraivalorInput"
                                title="subtraivalor"
                                :searchable="false"
                                :options="simNao"
                                v-model="subtraivalorSelected"
                                class="no-clear"
                                tooltipLabel="informacao-tipopedido-subtraivalor"
                                tooltipPosition="is-left"
                                :required="true"
                                :mlLabels="true"
                                :disabled="cantEdit"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                :id="generateId(12)"
                                ref="bloqsaldonegativoInput"
                                title="bloqsaldonegativo"
                                :searchable="false"
                                :options="simNao"
                                v-model="bloqsaldonegativoSelected"
                                class="no-clear"
                                tooltipLabel="informacao-tipopedido-bloqsaldonegativo"
                                tooltipPosition="is-right"
                                :required="true"
                                :mlLabels="true"
                                :disabled="cantEdit"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                :id="generateId(13)"
                                ref="bloqsemvendaInput"
                                title="bloqsemvenda"
                                :searchable="false"
                                :options="simNao"
                                v-model="bloqsemvendaSelected"
                                class="no-clear"
                                tooltipLabel="informacao-tipopedido-bloqsemvenda"
                                tooltipPosition="is-top"
                                :required="true"
                                :mlLabels="true"
                                :disabled="cantEdit"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                :id="generateId(14)"
                                ref="ignorapedminprazoInput"
                                title="ignorapedminprazo"
                                :searchable="false"
                                :options="simNao"
                                v-model="ignorapedminprazoSelected"
                                class="no-clear"
                                tooltipLabel="informacao-tipopedido-ignorapedminprazo"
                                tooltipPosition="is-top"
                                :required="true"
                                :mlLabels="true"
                                :disabled="cantEdit"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                :id="generateId(16)"
                                ref="colunavendaInput"
                                title="colunavenda"
                                :searchable="false"
                                :options="umASete"
                                v-model="colunavendaSelected"
                                class="no-clear"
                                tooltipLabel="informacao-tipopedido-colunavenda"
                                tooltipPosition="is-left"
                                :required="true"
                                :mlLabels="false"
                                :disabled="cantEdit"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                :id="generateId(17)"
                                ref="colunatrocaInput"
                                title="colunatroca"
                                :searchable="false"
                                :options="umASete"
                                v-model="colunatrocaSelected"
                                class="no-clear"
                                tooltipLabel="informacao-tipopedido-colunatroca"
                                tooltipPosition="is-right"
                                :required="true"
                                :mlLabels="false"
                                :disabled="cantEdit"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                :id="generateId(18)"
                                ref="colunabonificacaoInput"
                                title="colunabonificacao"
                                :searchable="false"
                                :options="umASete"
                                v-model="colunabonificacaoSelected"
                                class="no-clear"
                                tooltipLabel="informacao-tipopedido-colunabonificacao"
                                tooltipPosition="is-top"
                                :required="true"
                                :mlLabels="false"
                                :disabled="cantEdit"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                        <div class="column is-3">
                            <v-money
                                :id="generateId(19)"
                                ref="valormaximotrocaInput"
                                title="valormaximotroca"
                                msg="msg-campo-obrigatorio"
                                v-model="tipopedido.valormaximotroca"
                                :invalid="isNull(tipopedido.valormaximotroca)"
                                :max="9999999"
                                :required="true"
                                tooltipLabel="informacao-tipopedido-valormaximotroca"
                                tooltipPosition="is-top"
                                tooltipSize="is-large"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-3">
                            <v-money
                                :id="generateId(20)"
                                ref="valorminimotrocaInput"
                                title="valorminimotroca"
                                msg="msg-campo-obrigatorio"
                                v-model="tipopedido.valorminimotroca"
                                :invalid="isNull(tipopedido.valorminimotroca)"
                                :max="9999999"
                                :required="true"
                                tooltipLabel="informacao-tipopedido-valorminimotroca"
                                tooltipPosition="is-left"
                                tooltipSize="is-large"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-4">
                            <v-money
                                :id="generateId(20)"
                                ref="percmaxdescontoInput"
                                title="percmaxdesconto"
                                msg="msg-campo-obrigatorio"
                                v-model="tipopedido.percmaxdesconto"
                                :invalid="isNull(tipopedido.percmaxdesconto)"
                                :max="100"
                                :required="true"
                                tooltipLabel="informacao-tipopedido-percmaxdesconto"
                                tooltipPosition="is-right"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-5">
                            <v-money
                                :id="generateId(20)"
                                ref="porcmaxbonifsobvendaInput"
                                title="porcmaxbonifsobvenda"
                                msg="msg-campo-obrigatorio"
                                v-model="tipopedido.porcmaxbonifsobvenda"
                                :invalid="isNull(tipopedido.porcmaxbonifsobvenda)"
                                :max="100"
                                :required="true"
                                tooltipLabel="informacao-tipopedido-porcmaxbonifsobvenda"
                                tooltipPosition="is-top"
                                tooltipSize="is-large"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                :id="generateId(50)"
                                ref="situacaoSelect"
                                title="situacao"
                                :searchable="false"
                                :options="situacaoSelect"
                                v-model="situacaoSelected"
                                class="no-clear"
                                :mlLabels="true"
                                :disabled="cantEdit || isNull(tipopedido.id)"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                        <div class="column is-6">
                            <vss-select
                                :id="generateId(51)"
                                ref="geratitulopromissoriaInput"
                                title="geratitulopromissoria"
                                :searchable="false"
                                :options="geratitulopromissoriaSelect"
                                v-model="geratitulopromissoriaSelected"
                                class="no-clear"
                                tooltipLabel="informacao-geratitulopromissoria"
                                tooltipPosition="is-right"
                                :required="true"
                                :mlLabels="true"
                                :disabled="cantEdit"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EmpresaService from '@/services/vendas/empresa/EmpresaService';
import AssTipoPedidoClienteService from '@/services/vendas/cliente/abas/AssTipoPedidoClienteService';
import TipoPedidoService from '@/services/vendas/TipoPedidoService';
import TipoPedidoValidation from '@/services/validations/vendas/TipoPedidoValidation';

export default {
    data() {
        return {
            assTipoPedidoClienteIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'ASSTIPOPEDIDOCLIENTE'
            ),
            empresaService: new EmpresaService(this.$http, this.$router),
            integracao: this.$store.state.user.tabelasERPWebServer.includes('TIPOPEDIDO'),
            service: new TipoPedidoService(this.$http, this.$router),
            serviceAss: new AssTipoPedidoClienteService(this.$http, this.$router),
            isLoading: false,
            isSaving: false,
            validation: new TipoPedidoValidation(this.$root.msgs),
            tipopedido: {
                id: null,
                idtipopedidoerp: '',
                idtipopedido: null,
                idempresa: 0,
                descricao: null,
                situacao: null,
                // select de 1 a 7
                colunavenda: null,
                colunatroca: null,
                colunabonificacao: null,
                // sim não
                geraimposto: null,
                fatura: null,
                imprime: null,
                negativaestoquelocal: null,
                habilitaordemcompra: null,
                solicitacontrasenha: null,
                solicitamotivotipopedido: null,
                alertasaldominimo: null,
                descflexvlrmenor: null,
                acresflexvlrmaior: null,
                consomeFlexPedVinculado: null,
                subtraivalor: null,
                bloqsaldonegativo: null,
                bloqsemvenda: null,
                ignorapedminprazo: null,
                descvalortotalitemflex: null,
                // select B, T ou V
                tipo: null,
                // double
                valormaximotroca: 0,
                valorminimotroca: 0,
                porcmaxbonifsobvenda: 0,
                percmaxdesconto: 0,
                geratitulopromissoria: 0,
            },

            isUpdate: false,
            isSearchingCNPJ: false,
            invalidCNPJ: true,
            invalidCNPJMsg: 'msg-campo-obrigatorio',
            cantEdit: false,

            situacaoSelect: [
                { id: 0, label: 'inativo' },
                { id: 1, label: 'ativo' },
            ],
            situacaoSelected: { id: 1, label: 'ativo' },

            simNao: [
                { id: 0, label: 'nao' },
                { id: 1, label: 'sim' },
            ],
            geraimpostoSelected: { id: 0, label: 'nao' },
            faturaSelected: { id: 0, label: 'nao' },
            imprimeSelected: { id: 0, label: 'nao' },
            negativaestoquelocalSelected: { id: 0, label: 'nao' },
            habilitaordemcompraSelected: { id: 1, label: 'sim' },
            solicitacontrasenhaSelected: { id: 0, label: 'nao' },
            solicitamotivotipopedidoSelected: { id: 0, label: 'nao' },
            alertasaldominimoSelected: { id: 0, label: 'nao' },
            descflexvlrmenorSelected: { id: 1, label: 'sim' },
            consomeFlexPedVinculadoSelected: { id: 0, label: 'nao' },
            acresflexvlrmaiorSelected: { id: 1, label: 'sim' },
            subtraivalorSelected: { id: 0, label: 'nao' },
            bloqsaldonegativoSelected: { id: 0, label: 'nao' },
            bloqsemvendaSelected: { id: 0, label: 'nao' },
            ignorapedminprazoSelected: { id: 0, label: 'nao' },
            descvalortotalitemflexSelected: { id: 0, label: 'nao' },

            tipoSelect: [
                { id: 'B', label: 'bonificacao' },
                { id: 'T', label: 'troca' },
                { id: 'V', label: 'venda' },
            ],
            tipoSelected: { id: 'V', label: 'venda' },

            umASete: [
                { id: 1, label: '1' },
                { id: 2, label: '2' },
                { id: 3, label: '3' },
                { id: 4, label: '4' },
                { id: 5, label: '5' },
                { id: 6, label: '6' },
                { id: 7, label: '7' },
            ],
            colunavendaSelected: { id: 1, label: '1' },
            colunatrocaSelected: { id: 1, label: '1' },
            colunabonificacaoSelected: { id: 1, label: '1' },

            empresaSelect: [{ id: 0, label: this.$t('todas').toUpperCase() }],
            empresaSelected: { id: 0, label: this.$t('todas').toUpperCase() },

            geratitulopromissoriaSelect: [
                { id: 0, label: 'tipopedido-nao-gera-titulo-e-promissoria' },
                { id: 1, label: 'tipopedido-gera-titulo' },
                { id: 2, label: 'tipopedido-gera-titulo-e-promissoria' },
            ],
            geratitulopromissoriaSelected: {
                id: 0,
                label: 'tipopedido-nao-gera-titulo-e-promissoria',
            },
            permissao: false,
            permissaoVincular: false,

            isLoadingEdit: false,
            isChanged: false,
            empresasLoading: false,
        };
    },
    watch: {
        tipopedido: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.isChanged = true;
                }
            },
        },
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;
        this.permissao = this.hasPermissionAccess('vendas', 'vendas', 'ven-tipopedido');
        this.permissaoVincular = this.permissao.create && !this.assTipoPedidoClienteIntegracao;
        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'tipopedido' },
            });
        } else {
            this.carregarEmpresas('').then((r) => {
                this.cantEdit = !this.permissao.update || this.integracao;
                if (this.isUpdate) this.carregarDados();
            });
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        sendIsChanged() {
            if (!this.isLoadingEdit) this.isChanged = true;
        },
        carregarDados() {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.service
                .find(this.$route.params.id)
                .then((value) => {
                    this.tipopedido = value.content;
                    this.situacaoSelected = this.situacaoSelect[this.tipopedido.situacao];

                    this.empresaSelected = this.empresaSelect.filter(
                        (f) => f.id == this.tipopedido.idempresa
                    )[0];

                    // select B, T ou V
                    if (!this.isNull(this.tipopedido.tipo)) {
                        this.tipoSelected = this.tipoSelect.filter((f) => {
                            return f.id == this.tipopedido.tipo;
                        })[0];
                    }
                    // sim não em texto
                    if (!this.isNull(this.tipopedido.subtraivalor)) {
                        this.subtraivalorSelected =
                            this.tipopedido.subtraivalor == 'N' ? this.simNao[0] : this.simNao[1];
                    }
                    if (!this.isNull(this.tipopedido.bloqsaldonegativo)) {
                        this.bloqsaldonegativoSelected =
                            this.tipopedido.bloqsaldonegativo == 'N'
                                ? this.simNao[0]
                                : this.simNao[1];
                    }
                    if (!this.isNull(this.tipopedido.bloqsemvenda)) {
                        this.bloqsemvendaSelected =
                            this.tipopedido.bloqsemvenda == 'N' ? this.simNao[0] : this.simNao[1];
                    }
                    // // select de 1 a 7
                    if (!this.isNull(this.tipopedido.colunavenda)) {
                        this.colunavendaSelected = this.umASete.filter((f) => {
                            return f.id == this.tipopedido.colunavenda;
                        })[0];
                    }
                    if (!this.isNull(this.tipopedido.colunatroca)) {
                        this.colunatrocaSelected = this.umASete.filter((f) => {
                            return f.id == this.tipopedido.colunatroca;
                        })[0];
                    }
                    if (!this.isNull(this.tipopedido.colunabonificacao)) {
                        this.colunabonificacaoSelected = this.umASete.filter((f) => {
                            return f.id == this.tipopedido.colunabonificacao;
                        })[0];
                    }
                    if (!this.isNull(this.tipopedido.geratitulopromissoria)) {
                        this.geratitulopromissoriaSelected = this.geratitulopromissoriaSelect.filter(
                            (f) => {
                                return f.id == this.tipopedido.geratitulopromissoria;
                            }
                        )[0];
                    }
                    // sim não
                    if (!this.isNull(this.tipopedido.geraimposto)) {
                        this.geraimpostoSelected = this.simNao[this.tipopedido.geraimposto];
                    }
                    if (!this.isNull(this.tipopedido.fatura)) {
                        this.faturaSelected = this.simNao[this.tipopedido.fatura];
                    }
                    if (!this.isNull(this.tipopedido.imprime)) {
                        this.imprimeSelected = this.simNao[this.tipopedido.imprime];
                    }
                    if (!this.isNull(this.tipopedido.negativaestoquelocal)) {
                        this.negativaestoquelocalSelected = this.simNao[
                            this.tipopedido.negativaestoquelocal
                        ];
                    }
                    if (!this.isNull(this.tipopedido.habilitaordemcompra)) {
                        this.habilitaordemcompraSelected = this.simNao[
                            this.tipopedido.habilitaordemcompra
                        ];
                    }
                    if (!this.isNull(this.tipopedido.solicitacontrasenha)) {
                        this.solicitacontrasenhaSelected = this.simNao[
                            this.tipopedido.solicitacontrasenha
                        ];
                    }
                    if (!this.isNull(this.tipopedido.solicitamotivotipopedido)) {
                        this.solicitamotivotipopedidoSelected = this.simNao[
                            this.tipopedido.solicitamotivotipopedido
                        ];
                    }
                    if (!this.isNull(this.tipopedido.alertasaldominimo)) {
                        this.alertasaldominimoSelected = this.simNao[
                            this.tipopedido.alertasaldominimo
                        ];
                    }
                    if (!this.isNull(this.tipopedido.descflexvlrmenor)) {
                        this.descflexvlrmenorSelected = this.simNao[
                            this.tipopedido.descflexvlrmenor
                        ];
                    }
                    if (!this.isNull(this.tipopedido.consomeFlexPedVinculado)) {
                        this.consomeFlexPedVinculadoSelected = this.simNao[
                            this.tipopedido.consomeFlexPedVinculado
                        ];
                    }
                    if (!this.isNull(this.tipopedido.acresflexvlrmaior)) {
                        this.acresflexvlrmaiorSelected = this.simNao[
                            this.tipopedido.acresflexvlrmaior
                        ];
                    }
                    if (!this.isNull(this.tipopedido.ignorapedminprazo)) {
                        this.ignorapedminprazoSelected = this.simNao[
                            this.tipopedido.ignorapedminprazo
                        ];
                    }
                    if (!this.isNull(this.tipopedido.descvalortotalitemflex)) {
                        this.descvalortotalitemflexSelected = this.simNao[
                            this.tipopedido.descvalortotalitemflex
                        ];
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.$root.showMessage('error', 'msg-erro-load', true);
                })
                .finally((_) => {
                    this.validateCNPJInner();
                    this.isLoading = false;
                    this.isLoadingEdit = false;
                    this.isChanged = false;
                });
        },
        validateCNPJInner() {
            if (this.isNull(this.tipopedido.descricao)) {
                this.invalidCNPJ = true;
                this.invalidCNPJMsg = 'msg-campo-obrigatorio';
            } else if (
                !this.isNull(this.tipopedido.descricao) &&
                !this.validateCnpj(this.tipopedido.descricao)
            ) {
                this.invalidCNPJ = true;
                this.invalidCNPJMsg = 'msg-campo-invalido';
            } else {
                this.invalidCNPJ = false;
            }
        },

        save() {
            this.isLoading = true;
            this.isLoadingEdit = false;

            if (this.validation.validate(this.tipopedido, this.$refs)) {
                let tipopedidoTemp = Object.assign({}, this.tipopedido);
                tipopedidoTemp = this.mapTosave(tipopedidoTemp);
                tipopedidoTemp.situacao = this.situacaoSelected.id;
                tipopedidoTemp.idempresa = this.empresaSelected.id;

                // sim não em texto
                tipopedidoTemp.subtraivalor = this.subtraivalorSelected.id == 0 ? 'N' : 'S';
                tipopedidoTemp.bloqsaldonegativo =
                    this.bloqsaldonegativoSelected.id == 0 ? 'N' : 'S';
                tipopedidoTemp.bloqsemvenda = this.bloqsemvendaSelected.id == 0 ? 'N' : 'S';
                // sim não
                tipopedidoTemp.geraimposto = this.geraimpostoSelected.id;
                tipopedidoTemp.fatura = this.faturaSelected.id;
                tipopedidoTemp.imprime = this.imprimeSelected.id;
                tipopedidoTemp.negativaestoquelocal = this.negativaestoquelocalSelected.id;
                tipopedidoTemp.habilitaordemcompra = this.habilitaordemcompraSelected.id;
                tipopedidoTemp.solicitacontrasenha = this.solicitacontrasenhaSelected.id;
                tipopedidoTemp.solicitamotivotipopedido = this.solicitamotivotipopedidoSelected.id;
                tipopedidoTemp.alertasaldominimo = this.alertasaldominimoSelected.id;
                tipopedidoTemp.descflexvlrmenor = this.descflexvlrmenorSelected.id;
                tipopedidoTemp.consomeFlexPedVinculado = this.consomeFlexPedVinculadoSelected.id;
                tipopedidoTemp.acresflexvlrmaior = this.acresflexvlrmaiorSelected.id;
                tipopedidoTemp.ignorapedminprazo = this.ignorapedminprazoSelected.id;
                tipopedidoTemp.descvalortotalitemflex = this.descvalortotalitemflexSelected.id;
                // select B, T ou V
                tipopedidoTemp.tipo = this.tipoSelected.id;
                // select de 1 a 7
                tipopedidoTemp.colunavenda = this.colunavendaSelected.id;
                tipopedidoTemp.colunatroca = this.colunatrocaSelected.id;
                tipopedidoTemp.colunabonificacao = this.colunabonificacaoSelected.id;
                tipopedidoTemp.geratitulopromissoria = this.geratitulopromissoriaSelected.id;

                this.isSaving = true;
                this.service
                    .save(tipopedidoTemp)
                    .then((value) => {
                        if (value.message == null) {
                            // novo modelo de mensagem dinâmica
                            let msg = this.$t(
                                    this.tipopedido.idtipopedido != null
                                        ? 'msg-edit-sucesso-n'
                                        : 'msg-save-sucesso-n', 
                                    { n: this.$t('tipopedido') }
                                );
                            this.isChanged = false;
                            this.$root.showMessage('success', msg, true, false);
                            // @85242
                            if (
                                this.permissaoVincular &&
                                !this.isUpdate &&
                                this.$route.query.tela == 'cliente-tipo-pedido'
                            ) {
                                this.promptConfirmaVinculo(value.content);
                            } else {
                                this.redirectToPage();
                            }
                        } else {
                            if (this.$te(value.message)) {
                                this.$root.showMessage('alert', value.message, true);
                            } else {
                                this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                            }
                        }
                    })
                    .catch((e) => {
                        let message = e.body.message;
                        if (message && this.$te(message)) {
                            if (message == 'msg-codigo-duplicado-n') {
                                this.$root.showMessage(
                                    'alert',
                                    this.$t(message, { n: tipopedidoTemp.idtipopedidoerp }),
                                    true,
                                    false
                                );
                            } else {
                                this.$root.showMessage('alert', message, true);
                            }
                        } else {
                            this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                        this.isLoadingEdit = false;
                    });
            } else {
                this.isLoading = false;
                this.isLoadingEdit = false;
            }
        },
        // @85242
        promptConfirmaVinculo(vinculo) {
            this.$root.confirm({
                message: this.$t('deseja-realizar-vinculo'),
                onConfirm: (_) => {
                    this.realizarVinculo(vinculo);
                },
                onCancel: (_) => {
                    this.redirectToPage();
                },
            });
        },
        // @85242
        realizarVinculo(vinculo) {
            this.isLoading = true;
            this.isLoadingEdit = true;
            let clienteTipoPedidoTemp = {
                tipopedido: this.tipopedido,
                idtipopedido: vinculo.idtipopedido,
                idcliente: this.$route.query['id'],
            };

            this.serviceAss
                .saveAss(clienteTipoPedidoTemp)
                .then((value) => {
                    if (value.message == null) {
                        this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
                        this.redirectToPage();
                    } else {
                        if (this.$t(value.message)) {
                            this.msgs.push(new Message('alert', value.message, true));
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message('alert', 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                    this.isLoadingEdit = false;
                });
        },
        fecharModal() {
            // @85242 - Confirmação ao fechar adicionada no tipopedido
            if (this.isChanged) {
                this.$root.confirm({
                    message: this.$t('msg-tem-certeza-alteracoes'),
                    onConfirm: (_) => {
                        this.isChanged = false;
                        this.redirectToPage();
                    },
                });
            } else {
                this.redirectToPage();
            }
        },
        redirectToPage() {
            let tempTela = null;
            let tempAba = null;

            // voltando para tela de ...
            if (this.$route.query.tela == 'cliente-tipo-pedido') {
                tempTela = `${this.$route.query.contexto}-cliente-politica-comercial-edit`;
                tempAba = 'tipo-pedido';
            }

            setTimeout(
                () => {
                    if (tempAba != null) {
                        this.$router.push({
                            name: tempTela,
                            params: { id: this.$route.query['id'] },
                            query: {
                                dadoscadastrais: this.$route.query.dadoscadastrais,
                                politicacomercial: this.$route.query.politicacomercial,
                                analisecomercial: this.$route.query.analisecomercial,
                            },
                        });
                    } else {
                        this.$router.push({ name: 'ven-tipopedido' });
                    }
                },
                tempAba != null ? 400 : 1000
            );
        },
        /*
            @84626
            retornar empresas que estão associadas a um usuário informado. Caso o usuário for admin,
            retorna todas as empresas

            @86436 foi necessario deixar as chamadas de carregarEmpresa e carregarDados de forma assincrona,
            pois as threads que rodam essas chamadas ocorriam concorrentemente e dessa forma, fazia com que
            o selectEmpresa nao conseguisse armazenar os dados a tempo
        */
        carregarEmpresas(q) {
            this.empresasLoading = true;
            return this.empresaService
                .findList(q)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `[TIPO PEDIDO] Erro status ${r.status} ao carregar empresas.`
                        );
                        console.error(`[TIPO PEDIDO] Mensagem: ${r.message}`);
                    } else {
                        r.content.map((e) => {
                            this.empresaSelect.push({
                                id: e.idempresa,
                                label: e.nome,
                            });
                        });
                    }
                })
                .catch((e) => {
                    console.error('[TIPO PEDIDO] Erro ao carregar empresas.', e);
                })
                .finally((_) => {
                    this.empresasLoading = false;
                });
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
}
</style>
